import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, ShoppingCartIcon, RotateCcwIcon, PackageIcon, TagIcon, GlobeIcon, TruckIcon, SettingsIcon, BellIcon, SearchIcon, LogOutIcon, ChevronRightIcon, UserIcon, MenuIcon } from 'lucide-react';
export const DealerDashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const location = useLocation();
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const menuItems = [{
    title: 'Dashboard',
    icon: <LayoutDashboardIcon className="h-5 w-5" data-id="element-1070" />,
    path: '/dealer'
  }, {
    title: 'Orders',
    icon: <ShoppingCartIcon className="h-5 w-5" data-id="element-1071" />,
    path: '/dealer/orders'
  }, {
    title: 'Returns',
    icon: <RotateCcwIcon className="h-5 w-5" data-id="element-1072" />,
    path: '/dealer/returns'
  }, {
    title: 'Inventory',
    icon: <PackageIcon className="h-5 w-5" data-id="element-1073" />,
    path: '/dealer/inventory'
  }, {
    title: 'Coupons',
    icon: <TagIcon className="h-5 w-5" data-id="element-1074" />,
    path: '/dealer/coupons'
  }, {
    title: 'Microsite',
    icon: <GlobeIcon className="h-5 w-5" data-id="element-1075" />,
    path: '/dealer/microsite'
  }, {
    title: 'Shipping',
    icon: <TruckIcon className="h-5 w-5" data-id="element-1076" />,
    path: '/dealer/shipping'
  }, {
    title: 'Settings',
    icon: <SettingsIcon className="h-5 w-5" data-id="element-1077" />,
    path: '/dealer/settings'
  }];
  return <div className="flex h-screen bg-gray-50" data-id="element-1078">
      {/* Mobile sidebar backdrop */}
      {isMobileSidebarOpen && <div className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden" onClick={toggleMobileSidebar} data-id="element-1079"></div>}
      {/* Sidebar for mobile */}
      <div className={`fixed inset-y-0 left-0 z-30 w-64 transform bg-white transition duration-300 lg:hidden ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-1080">
        <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200" data-id="element-1081">
          <Link to="/dealer" className="flex items-center" data-id="element-1082">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tpKLaYzfGrRLG8howg5M89/sellup-logo.png" alt="SellUp Dealer" className="h-8" data-id="element-1083" />
            <span className="ml-2 text-xl font-semibold text-gray-900" data-id="element-1084">
              Dealer
            </span>
          </Link>
          <button onClick={toggleMobileSidebar} className="text-gray-500 hover:text-gray-900" data-id="element-1085">
            <ChevronRightIcon className="h-6 w-6" data-id="element-1086" />
          </button>
        </div>
        <nav className="px-4 py-4" data-id="element-1087">
          <ul className="space-y-1" data-id="element-1088">
            {menuItems.map(item => <li key={item.title} data-id="element-1089">
                <Link to={item.path} className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive(item.path) ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setIsMobileSidebarOpen(false)} data-id="element-1090">
                  {item.icon}
                  <span className="ml-3" data-id="element-1091">{item.title}</span>
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
      {/* Sidebar for desktop */}
      <aside className={`hidden lg:block ${isSidebarOpen ? 'w-64' : 'w-20'} transition-width duration-300 bg-white border-r border-gray-200 flex flex-col`} data-id="element-1092">
        <div className="h-16 flex items-center justify-center border-b border-gray-200" data-id="element-1093">
          <Link to="/dealer" className="flex items-center" data-id="element-1094">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tpKLaYzfGrRLG8howg5M89/sellup-logo.png" alt="SellUp Dealer" className="h-8" data-id="element-1095" />
            {isSidebarOpen && <span className="ml-2 text-xl font-semibold text-gray-900" data-id="element-1096">
                Dealer
              </span>}
          </Link>
        </div>
        <nav className="flex-1 py-4 overflow-y-auto" data-id="element-1097">
          <ul className="px-2 space-y-1" data-id="element-1098">
            {menuItems.map(item => <li key={item.title} data-id="element-1099">
                <Link to={item.path} className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${isActive(item.path) ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-1100">
                  {item.icon}
                  {isSidebarOpen && <span className="ml-3" data-id="element-1101">{item.title}</span>}
                </Link>
              </li>)}
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-200" data-id="element-1102">
          <button onClick={toggleSidebar} className="w-full flex items-center justify-center p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md" data-id="element-1103">
            <ChevronRightIcon className={`h-5 w-5 transition-transform ${isSidebarOpen ? '' : 'transform rotate-180'}`} data-id="element-1104" />
            {isSidebarOpen && <span className="ml-2" data-id="element-1105">Collapse</span>}
          </button>
        </div>
      </aside>
      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1106">
        {/* Header */}
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 lg:px-6" data-id="element-1107">
          <div className="flex items-center" data-id="element-1108">
            <button onClick={toggleMobileSidebar} className="lg:hidden text-gray-500 hover:text-gray-900 mr-4" data-id="element-1109">
              <MenuIcon className="h-6 w-6" data-id="element-1110" />
            </button>
            <div className="relative w-64 hidden sm:block" data-id="element-1111">
              <input type="text" placeholder="Search..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1112" />
              <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1113" />
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-1114">
            <div className="relative" data-id="element-1115">
              <button className="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md" data-id="element-1116">
                <BellIcon className="h-5 w-5" data-id="element-1117" />
                <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full" data-id="element-1118"></span>
              </button>
            </div>
            <div className="flex items-center" data-id="element-1119">
              <div className="h-8 w-8 bg-blue-500 rounded-full flex items-center justify-center text-white" data-id="element-1120">
                <UserIcon className="h-5 w-5" data-id="element-1121" />
              </div>
              <span className="ml-2 font-medium text-gray-700 hidden sm:block" data-id="element-1122">
                TechHub Singapore
              </span>
            </div>
            <Link to="/login" className="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md" data-id="element-1123">
              <LogOutIcon className="h-5 w-5" data-id="element-1124" />
            </Link>
          </div>
        </header>
        {/* Main Content Area */}
        <main className="flex-1 overflow-auto p-6 bg-gray-50" data-id="element-1125">
          <Outlet data-id="element-1126" />
        </main>
      </div>
    </div>;
};